export class Uid {
    prefix;
    id = 0;
    constructor(prefix = '') {
        this.prefix = prefix;
    }
    get Next() {
        this.id += 1;
        return `${this.prefix}:${this.id}`;
    }
}
